export function stripHtmlTag(html: string) {
  // 使用 DOMParser 来解析 HTML 字符串
  const parser = new DOMParser();
  const doc = parser.parseFromString(html.replace(/<br\s*\/?>/gi, '\n'), 'text/html');
  return doc.body.textContent || '';
}
